
const cln_json_data = function (d) {

	return JSON.parse(JSON.stringify(d))

}

export default cln_json_data